<template>
  <div>
    <h1 class="text-pagename">Set store on app</h1>
    <v-card class="mx-3">
      <h3 class="text-xs-left py-2 ml-3">Sort store popular</h3>

      <v-layout row wrap justify-center>
        <v-flex xs12 md8>
          <draggable
            :list="store_popular_list"
            :disabled="!enabled"
            class="list-group"
            ghost-class="ghost"
            @start="dragging = true"
            @end="dragging = false"
          >
            <v-card
              class="list-group-item card-sort-popular"
              v-for="(element, index) in store_popular_list"
              :key="index"
              dark
            >
              <label>{{ element.store_popular_name_th }}</label>
              <v-btn
                icon
                small
                color="red"
                @click="delStorepopularList(index, element)"
              >
                <v-icon>remove</v-icon>
              </v-btn>
            </v-card>
          </draggable>
          <v-btn
            @click="applyStorePopular()"
            :loading="apply_popular_check == 1 || loading_message"
            :disabled="apply_popular_check == 1 || loading_message"
            color="primary"
            class="black--text"
            >Apply</v-btn
          >
          <div>
            <span v-if="apply_popular_check == 2" style="color: green"
              >(Successfully)</span
            >
          </div>
          <div>
            <span v-if="apply_popular_check == 3" style="color: red"
              >(Can't apply)</span
            >
          </div>
        </v-flex>
      </v-layout>
    </v-card>
    <h3 class="mt-3 ml-4 pl-1 text-xs-left">Store list</h3>
    <v-layout row>
      <!-- <v-flex xs4></v-flex>
      <v-flex xs4>
        <v-spacer></v-spacer>
      </v-flex>-->
      <v-flex xs12>
        <v-toolbar dense flat>
          <v-text-field
            v-model="search"
            prepend-icon="search"
            label="Search"
            single-line
            hide-details
            style="padding: 0"
          ></v-text-field>
        </v-toolbar>
      </v-flex>
    </v-layout>
    <v-data-table
      :search="search"
      :headers="headers"
      :loading="loading_message"
      :items="store_list"
      :pagination.sync="pagination"
    >
      <template slot="items" slot-scope="props">
        <td class="text-xs-center">{{ store_list.indexOf(props.item) + 1 }}</td>
        <td class="text-xs-center">{{ props.item.store_code }}</td>
        <td class="text-xs-center">{{ props.item.store_name_th }}</td>
        <td class="text-xs-center">{{ props.item.store_country_tel }}</td>
        <td class="text-xs-center">{{ groupStoreTel(props.item) }}</td>
        <td class="text-xs-center" style="position: relative">
          <v-switch
            :disabled="
              props.item.store_popular == false && disable_popular == true
                ? true
                : false
            "
            v-model="props.item.store_popular"
            @change="popularType(props.item)"
            color="primary"
            class="popular_toggle"
          ></v-switch>
        </td>
      </template>

      <template slot="no-data">
        <div v-if="loading_message == false">No data available</div>
        <div v-else>
          <v-progress-circular
            :size="30"
            color="primary"
            indeterminate
          ></v-progress-circular
          >Loading data ...
        </div>
      </template>
    </v-data-table>

    <!-- <div class="text-xs-center py-2">
      <v-pagination circle v-model="pagination.page" :length="pages"></v-pagination>
    </div>-->
  </div>
</template>

<script>
import draggable from "vuedraggable";
import { mapState } from "vuex";
export default {
  data: () => ({
    search: "",
    apply_popular_check: 0,
    dragging: false,
    list: [
      { name: "John", id: 0 },
      { name: "Joao", id: 1 },
      { name: "Jean", id: 2 },
    ],
    enabled: true,
    loading_message: false,
    disable_popular: false,
    store_name_th: null,
    pagination: {
      rowsPerPage: 10,
      page: 1,
      totalItems: 0,
    },
    headers: [
      {
        text: "No.",
        align: "center",
        sortable: false,
        value: "id",
      },
      {
        text: "Store code",
        align: "center",
        sortable: false,
        value: "store_code",
      },
      {
        text: "Store Name",
        align: "center",
        value: "store_name_th",
        sortable: false,
      },
      {
        text: "Country code",
        align: "center",
        value: "store_country_tel",
        sortable: false,
      },
      {
        text: "Tel.",
        align: "center",
        value: "store_tel",
        sortable: false,
      },
      {
        text: "Popular",
        align: "center",
        value: "popular",
        sortable: false,
      },
    ],
  }),
  components: {
    draggable,
  },
  computed: {
    ...mapState({
      store_detail_id: (state) => state.storeBack.store_detail_id,
      store_list: (state) => state.fetchStoreBack.store_list,
      store_popular_list: (state) => state.fetchStoreBack.store_popular_list,
    }),
    draggingInfo() {
      return this.dragging ? "under drag" : "";
    },
    pages() {
      if (this.length != 0) {
        this.pagination.totalItems = this.store_list.length;
      }
      if (
        this.pagination.rowsPerPage == null ||
        this.pagination.totalItems == null
      )
        return 0;

      return Math.ceil(
        this.pagination.totalItems / this.pagination.rowsPerPage
      );
    },
  },
  watch: {
    store_popular_list: {
      handler: function () {
        this.apply_popular_check = 0;
      },
      deep: true,
    },
    dialog(val) {
      val || this.close();
    },
    store_list: {
      handler: function () {
        let count = 0;
        for (let val of this.store_list) {
          if (val.store_popular == true) {
            count++;
          }
        }
        if (count >= 5) {
          this.disable_popular = true;
        } else {
          this.disable_popular = false;
        }
      },
      deep: true,
    },
  },

  created() {
    this.fetchData();
  },

  methods: {
    groupStoreTel(item) {
      let store_tel_temp = "";
      if (item.store_tel.constructor === Array) {
        for (let val of item.store_tel) {
          let index = item.store_tel.indexOf(val);
          if (index <= item.store_tel.length - 1) {
            store_tel_temp = store_tel_temp + val.tel;
          }
          if (index != item.store_tel.length - 1) {
            store_tel_temp = store_tel_temp + ",";
          }
        }
      }
      item.store_tel_temp = store_tel_temp;
      return store_tel_temp;
    },
    async applyStorePopular() {
      this.apply_popular_check = 1;
      for (let val of this.store_popular_list) {
        if (val.store_popular_id) {
          delete val.store_popular_id;
        }
      }
      this.apply_popular_check = await this.$store.dispatch(
        "fetchStoreBack/applyStorePopular",
        this.store_popular_list
      );
    },
    delStorepopularList(index, item) {
      this.store_popular_list.splice(index, 1);
      this.store_list.some((val) => {
        if (val.store_id == item.store_popular_store_id) {
          val.store_popular = false;
        }
      });
    },
    async popularType(item) {
      if (item.store_popular == true) {
        let push_item = {
          store_popular_code: item.store_code,
          store_popular_name_th: item.store_name_th,
          store_popular_country_tel: item.store_country_tel,
          store_popular_tel: item.store_tel,
          store_popular_email: item.store_email,
          store_popular_active: item.store_active,
          store_popular_popular: item.store_popular,
          store_popular_store_id: item.store_id,
        };
        this.store_popular_list.push(push_item);
      } else {
        let index = this.store_popular_list.findIndex(
          (val) => val.store_popular_store_id == item.store_id
        );
        this.store_popular_list.splice(index, 1);
      }
    },
    async fetchData() {
      this.loading_message = true;
      this.$store.commit("fetchStoreBack/getStorepopularList", []);
      await this.$store.dispatch("fetchStoreBack/getStoreList");
      await this.$store.dispatch("fetchStoreBack/getPopularList");
      this.loading_message = false;
      await this.$store.dispatch("fetchStoreBack/getDataType");
      await this.$store.dispatch(
        "fetchPackageBack/getData",
        this.$route.params.province
      );
    },
  },
};
</script>

<style scoped>
.popular_toggle {
  position: absolute;
  top: 13px;
  left: 40%;
}

.card-sort-popular {
  cursor: move;
  position: relative;
  height: 40px;
  position: relative;
  margin: 1px;
}

.card-sort-popular label {
  margin: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}

.card-sort-popular button {
  position: absolute;
  right: 0;
}
</style>


